import { useSearchParams } from "react-router";

export function useQueryParams<
    T extends Record<string, string | undefined>,
>(): T {
    const [searchParams] = useSearchParams();

    // 将查询参数解构成一个对象
    const queryParams: Record<string, string | undefined> = {};
    searchParams.forEach((value, key) => {
        queryParams[key] = value || undefined;
    });

    return queryParams as T;
}
